module.exports = __webpack_public_path__ + "static/media/Decoration_Asian.f45c1283.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/outskirts/themedEvent/decorations/Decoration_Asian.png
// module id = 1342
// module chunks = 3